module.exports = __webpack_public_path__ + "3c27fd59862b03f27bb5ed694b9d9030.png";